import { computed, defineComponent } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "FilogixNavigation",
  props: {
    page: {
      type: String,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const pages = computed(() => ({
      "automatic-sync": {
        label: t("filogix.expertSync.automaticSync"),
        section: "automatic-sync",
        key: "automatic-sync"
      },
      "submit-to-filogix": {
        label: t("filogix.submitToFilogix"),
        section: "submit-to-filogix",
        key: "submit-to-filogix"
      }
    }));
    const handlePageChange = key => {
      emit("page-change", key);
    };
    return {
      pages,
      handlePageChange
    };
  }
});